// Redesign 2026 – odkaz „Odeslat další objednávku“ v poděkování Fluent Formu (FONDEFI).
// Text poděkování je v nastavení formuláře ve Fluent Forms, odkaz v něm má data-rd-ff-again.
// Odkaz vede na tutéž stránku s kotvou formuláře – prohlížeč by na něj jen poskočil a formulář
// by zůstal schovaný, proto se stránka načte znovu. Poděkování vkládá Fluent Forms až po odeslání,
// proto delegace z dokumentu.
export default function initRedesignFfAgain() {
  if (!document.querySelector('.fluentform')) {
    return;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-rd-ff-again]');
    if (!link) {
      return;
    }
    event.preventDefault();
    window.history.replaceState(null, '', link.href);
    window.location.reload();
  });
}
